import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Baseproperties } from '../../utility/baseproperties';

@Injectable({
  providedIn: 'root'
})
export class LocationtypeService {
 
    constructor(private httpClient: HttpClient) { }
    baseproperties: Baseproperties = new Baseproperties();
    private baseURL = this.baseproperties.gatewayBaseURL + "/common/locationtype"
  
    getModify(locationtypeid): Observable<any> {
      return this.httpClient.get(`${this.baseURL}/getmodify/${locationtypeid}`);
    }
    getData(): Observable<any[]> {
      return this.httpClient.get<any[]>(`${this.baseURL}/getdata`);
    }
    addLocationType(payload): Observable<Object> {
      return this.httpClient.post(`${this.baseURL}/addlocationtype`, payload);
    }
    modifyLocationType(payload): Observable<Object> {
      return this.httpClient.post(`${this.baseURL}/modifylocationtype`, payload);
    }

    getExcelData() {
    return this.httpClient.post(`${this.baseURL}/getexcel`, {}, { responseType: 'blob' as 'json' });
  }

    getConfiguration(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.baseURL}/getconfiguration`);
  }
}
